import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Button } from '../ui/Button';
const features = ['Método paso a paso, fácil de aplicar', 'Enfoque respetuoso para el niño', 'Acompaña el día y la noche', 'Formato digital: PDF + checklists + audio'];
export function HeroSection() {
  return <section className="min-h-screen bg-gradient-to-b from-navy via-navy to-[#243352] text-white py-12 md:py-20 px-4" data-id="element-64">
      <div className="max-w-6xl mx-auto" data-id="element-65">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-66">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-67">
            <p className="text-gold font-medium mb-4 tracking-wide" data-id="element-68">
              by Hogar Bienestar
            </p>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight mb-6" data-id="element-69">
              Noches Secas: el método respetuoso para ayudar a tu hijo a dejar
              el pipí en la cama y en la ropa
            </h1>

            <p className="text-xl text-white/80 mb-8 leading-relaxed" data-id="element-70">
              Una guía práctica y emocional para acompañar este proceso sin
              castigos, sin culpa y con rutinas claras.
            </p>

            <ul className="space-y-3 mb-10" data-id="element-71">
              {features.map((feature, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.3 + index * 0.1
            }} className="flex items-start gap-3" data-id="element-72">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-gold/20 flex items-center justify-center mt-0.5" data-id="element-73">
                    <CheckIcon className="w-4 h-4 text-gold" data-id="element-74" />
                  </span>
                  <span className="text-white/90" data-id="element-75">{feature}</span>
                </motion.li>)}
            </ul>

            <Button data-id="element-76">Acceder al método Noches Secas</Button>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="relative" data-id="element-77">
            <div className="absolute inset-0 bg-gradient-to-r from-gold/20 to-soft-blue/20 rounded-3xl blur-3xl" data-id="element-78" />
            <img src="https://cdn.magicpatterns.com/uploads/tEiwUDpUwTSy8CX73r8GUS/1._MOCKUP_NOCHES_SECAS.png" alt="Noches Secas - Ebook, tablet y audio con auriculares mostrando el método de acompañamiento respetuoso para niños" className="relative w-full h-auto rounded-2xl" data-id="element-79" />
          </motion.div>
        </div>
      </div>
    </section>;
}